<ng-container>
  <div class="row shadow p-3 mb-4 bg-white rounded">
    <!-- Actions dropdown -->
    <div class="col-12 col-md-1 mb-3 mb-md-0 d-flex justify-content-start justify-content-md-center">
      <div ngbDropdown class="d-inline-block">
        <button class="btn btn-outline-primary btn-xs" ngbDropdownToggle>
          <span class="feather icon-list"></span>
        </button>
        <div ngbDropdownMenu class="shadow p-3 bg-white rounded">
          <a ngbDropdownItem (click)="download()">
            <span class="feather icon-download mr-1"></span> {{'htmlText.dwld' | translate}}
          </a>
          <a ngbDropdownItem (click)="navigateFn('m-b-s',{from:'pref_sell_price'})">
            <span class="feather icon-globe mr-1"></span> {{'mb.settings' | translate}}
          </a>
          <a ngbDropdownItem (click)="loginAs()">
            <span class="feather icon-user mr-1"></span>{{'mb.loginToAccount' | translate}}
          </a>
          <a ngbDropdownItem (click)="navigateFn('m-b-s',{ to: 's-s-p', from:'bulk_update'})">
            <span class="feather icon-layers mr-1"></span>
            {{'mb.bulkUpdate' | translate}}
          </a>
        </div>
      </div>
    </div>



    <!-- <div class="col-12 d-block d-sm-none text-right mb-2">
      <button class="btn btn-outline-secondary btn-sm" data-toggle="collapse" data-target="#filterCollapse"
        aria-expanded="false" aria-controls="filterCollapse">
        <span class="feather icon-filter"></span> Filters
      </button>
    </div> -->


    <div class="col-12 col-sm-8 col-md-8">
      <form [formGroup]="filterFormGroup">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 mb-2">
            <ng-select id="monthBox" formControlName="month" [items]="monthList" bindLabel="label" bindValue="value"
              placeholder="Month Selection" [clearable]="true">
            </ng-select>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mb-2">
            <ng-select id="year" formControlName="year" [items]="yearList" bindLabel="label" bindValue="value"
              placeholder="Year Selection" [clearable]="true">
            </ng-select>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mb-2">
            <ng-select [items]="merchants$ | async" formControlName="merchantId" [loading]="merchantLoading"
              [notFoundText]="merchantNotFoundText" [typeahead]="search$" bindLabel="dba" bindValue="id"
              placeholder="Search by Merchant" [clearable]="true" (search)="search$.next($event.term)">
            </ng-select>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mb-2">
            <ng-select [items]="invoiceIdsList" formControlName="invoiceNumber"
              (search)="onSearchInvoiceId($event.term)" bindLabel="invoiceNumber" bindValue="invoiceNumber"
              placeholder="Search By Invoice" [loading]="invoiceIdloading" clearAllText="Clear"
              [notFoundText]="notFoundText" [clearable]="true">
            </ng-select>
          </div>

          <div class="col-12 col-sm-6 col-md-4 mb-2">
            <ng-select [items]="status" formControlName="invoiceStatus" bindLabel="name" bindValue="id"
              placeholder="Invoice Status" [clearable]="true">
            </ng-select>
          </div>


        </div>

      </form>
    </div>

    <div class="ml-3">
      <div class="d-flex flex-wrap gap-2 w-100 w-md-auto">
        <button class="btn btn-outline-primary mr-2" [disabled]="!isFormValid" (click)="searchFn()">
          <i class="feather icon-search mr-1"></i> Search
        </button>
        <button class="btn btn-outline-primary mr-2" [disabled]="!isFormValid" type="button" (click)="clear();">
          Clear
        </button>
        <button class="btn btn-outline-primary" (click)="searchFn()">
          <i class="feather icon-refresh-cw"></i>
        </button>
      </div>
    </div>
  </div>


  <ng-container *ngIf="!isLoading && !billingNotebaled">

    <div class="card list-view card-list-bg mb-3">

      <div class="card-body carding p-3">

        <app-back-button [paramDest]="'merchantInvoicing'"></app-back-button>
        <div class="d-flex justify-content-around align-items-center" *ngIf="this.invoice?.invoices?.length">

          <div class="d-flex flex-column text-center" *ngIf="!filterMerchantInfo?.id">
            <div class="mb-1">
              <span>{{'mb.totalMerchants' | translate}}</span>
            </div>
            <div class="font-weight-bold mb-1">
              <h5>{{this.invoice?.summary?.totalMerchants}}</h5>
            </div>

          </div>
          <div class="d-flex flex-column text-center" *ngIf="filterMerchantInfo?.id">
            <div class="mb-1">
              <span>{{'mb.merchantDba' | translate}}</span>
            </div>
            <!-- <div class="font-weight-bold mb-1">
              <h5>{{filterMerchantInfo.dba}}</h5>
            </div> -->
            <div ngbDropdown container="body">
              <h5>
                <p class="over-flow" ngbDropdownToggle data-toggle="tooltip" data-placement="bottom"
                  title="Merchant DBA">
                  <u class="hover-text" style="cursor: pointer">{{filterMerchantInfo.dba}}
                  </u>
                </p>
              </h5>

              <div>
                <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                  <a ngbDropdownItem class="d-flex align-items-center" (click)="navigateToBilling(true)">
                    <span class="feather icon-edit mr-1">
                    </span>
                    <span>{{'Edit Invoicing'}}
                    </span>
                  </a>

                </div>
              </div>

            </div>

          </div>
          <div class="d-flex flex-column text-center">
            <div class="mb-1">
              <span>{{'mb.totalAmount' | translate}}</span>
            </div>
            <div class="font-weight-bold mb-1">
              <h5>{{invoice.summary?.collectedAmount |currency}}</h5>
            </div>
          </div>

          <div class="d-flex flex-column text-center">
            <div class="mb-1">
              <span>{{'mb.totalAmountPending' | translate}}</span>
            </div>
            <div class="font-weight-bold mb-1">
              <h5>{{invoice.summary?.pendingAmount |currency}}</h5>
            </div>

          </div>
          <div class="d-flex flex-column text-center">
            <div class="mb-1">
              <span>{{'mb.billedDate' | translate}}</span>
            </div>
            <div class="font-weight-bold mb-1">
              <h5>{{invoice.summary?.lastBillingDate ? (invoice.summary?.lastBillingDate |date :'d MMM y') : '--'}}
              </h5>
            </div>

          </div>




        </div>
        <div class="text-center">

          <h4 *ngIf="!this.invoice?.invoices?.length">No invoice found</h4>
        </div>
      </div>
    </div>

  </ng-container>

  <div *ngIf="this.invoice?.invoices?.length && !isLoading && !billingNotebaled" class="row chat-wrapper">
    <div class="col-md-12">
      <div class="card" style="background-color: #fff !important">
        <div class="card-body">
          <div class="row position-relative">

            <div class="col-lg-5 chat-aside border-lg-right">
              <div class="aside-content">
                <div class="card-header list-header width-heade-align">
                  <p class="card-text mt-1 col-md-12 pl-0 text-left"><span class="font-weight-bold">
                      {{'transactionInvoice' | translate}} ({{this.invoice?.summary?.totalMerchants}})</span></p>
                </div>
                <div class="aside-body">
                  <ul ngbNav #defaultNav="ngbNav" class="mt-3">
                    <li [ngbNavItem]="1">
                      <ng-template ngbNavContent>
                        <div #container class="container" *ngIf="!paginationLoader"
                          style="max-height: calc(100vh - 17rem) !important;" [perfectScrollbar]>
                          <p class="text-muted mb-1"></p>
                          <div (click)="selected(index)" [class.active]="viewMode == index"
                            class="ist-unstyled chat-list px-1 mb-2 back-ground-color back-hover"
                            *ngFor="let invoice of this.invoice?.invoices; let index = index">
                            <div class="chat-item pr-1">
                              <a (click)="currentInvoiceDetail(invoice)" class="d-flex align-items-center">
                                <div class="flex-grow">
                                  <div>
                                    <div class="d-flex justify-content-between">
                                      <p class="text-body over-flow ml-1"><span
                                          class="large-fontsize-label"><strong>{{invoice?.merchantDba ||
                                            'NA'}}</strong></span><span class="large-fontsize"></span>
                                      </p>
                                      <p class="text-body mr-1"><span
                                          class="large-fontsize-label"><strong>{{invoice?.invoiceStatus =='DECLINED' ? 'FAILED':invoice?.invoiceStatus}}</strong></span>
                                      </p>
                                    </div>
                                    <hr>
                                    <div class="text-body row">
                                      <div class="col-md-4 text-left">
                                        <dt>{{'invoice.period' | translate}}</dt>
                                        <dd>{{invoice?.month + '-' + 01 + '-' + invoice?.year |date :'MMM y'}}</dd>
                                      </div>
                                      <div class="col-md-4 pl-4">
                                        <dt>{{(invoice?.invoiceStatus =='APPROVED' || invoice?.invoiceStatus == 'PENDING' ? 'invoice.paid' : 'mb.failed') |
                                          translate}}</dt>
                                        <dd>{{ invoice?.billingDate ? (invoice?.billingDate |date :'d MMM y') :'--'}}
                                        </dd>

                                      </div>
                                      <div class="col-md-4 mt-2 text-right">
                                        <span class="" style="font-size: 18px;">
                                          <strong>{{invoice?.total | currency}}</strong>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>

                          </div>
                        </div>
                        <app-loading *ngIf="paginationLoader"> </app-loading>
                        <div class="mt-2">
                          <ngb-pagination class="d-flex justify-content-end mob-media mt-1"
                            [collectionSize]="collectionSize" [(page)]="page" [maxSize]="3" [rotate]="true"
                            [pageSize]="limit" (pageChange)="getPage(page)">
                          </ngb-pagination>
                        </div>

                      </ng-template>
                    </li>
                  </ul>
                  <div [ngbNavOutlet]="defaultNav" class=""></div>
                </div>
              </div>
            </div>

            <div *ngIf="this.invoice?.invoices?.length" class="col-lg-7 chat-content">
              <div class="chat-header pb-3">
                <div class="d-flex">
                  <div class="align-items-center flex-grow-1" [ngClass]="viewInvoice?.invoiceStatus">
                    <i class="feather icon-corner-up-left icon-md mr-2 ml-n2 text-muted d-lg-none"></i>
                    <div>
                      <h4 class="mt-1 ml-3">
                        {{viewInvoice?.invoiceStatus =='DECLINED' ? 'FAILED':viewInvoice?.invoiceStatus}}
                      </h4>
                    </div>
                  </div>
                  <div class="align-items-center ml-3 mt-1">
                    <div>
                      <h4>{{'invoice.invoiceNumber' | translate}} {{viewInvoice?.invoiceNumber}}</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chat-header border-bottom pb-2">
                <!-- <div class="d-flex">
                <div class="align-items-center flex-grow-1">
                  <i class="feather icon-corner-up-left icon-md mr-2 ml-n2 text-muted d-lg-none"></i>
                  <div>
                    <h4 class="mt-1 ml-1">
                      {{'invoice.summary' | translate}}
                    </h4>
                  </div>
                </div>
              </div> -->
                <div class="d-flex">
                  <div class="align-items-center flex-grow-1">
                    <i class="feather icon-corner-up-left icon-md mr-2 ml-n2 text-muted d-lg-none"></i>
                    <div>
                      <h4 class="mt-1">
                        {{'invoice.summary' | translate}}
                      </h4>
                    </div>
                  </div>
                  <div class="align-items-center ml-3 mt-1">
                    <div>
                      <h5>{{'invoice.generated' | translate}} {{viewInvoice?.generatedDate |date :'d MMM y' }}</h5>
                    </div>
                  </div>
                </div>

              </div>

              <div class="d-flex justify-content-end mt-2 mb-2 back-ground-color list p-2">
                <div ngbDropdown class="mt-1 flex-grow-1">
                  <span style="font-size: large" class="ml-3 mt-1"><strong>Total: {{viewInvoice?.total
                      |currency}}</strong></span>
                </div>
                <div class="ml-md-2">
                  <div class="d-inline-block" ngbDropdown [autoClose]="'outside'" #myDrop="ngbDropdown">
                    <button class="btn btn-more" id="dropdownManual" ngbDropdownToggle>

                      {{'invoice.more' | translate}}</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownManual" *ngIf="viewInvoice.invoiceStatus == 'APPROVED'">
                      <button ngbDropdownItem [disabled]="!!invoiceDownloadLoader || !viewInvoice.invoiceDetailsExcel " (click)="downloadInvoice(viewInvoice,'excel')">
                        <!-- <i data-feather="smartphone" appFeatherIcon
                          class="icon-sm mr-2"></i> -->
                        <span>{{'invoice.renderInvoice' | translate}}</span>
                        <i *ngIf="invoiceDownloadLoader == 'excel'" class="spinner-border spinner-border-sm ml-1 mt-1"
                          role="status" aria-hidden="true"></i>
                      </button>
                      <button ngbDropdownItem  [disabled]="!!invoiceDownloadLoader || !viewInvoice.invoicePdf" (click)="downloadInvoice(viewInvoice,'pdf')">
                        <!-- <i data-feather="check-circle" appFeatherIcon
                          class="icon-sm mr-2"></i> -->
                        <span>{{'invoice.renderInvoiceBill' | translate}}</span>
                        <i *ngIf="invoiceDownloadLoader == 'pdf'" class="spinner-border spinner-border-sm ml-1 mt-1"
                          role="status" aria-hidden="true"></i>
                      </button>
                    </div>

                    <div ngbDropdownMenu aria-labelledby="dropdownManual" *ngIf="viewInvoice.invoiceStatus != 'APPROVED'">
                      <button ngbDropdownItem [disabled]="true"> <i data-feather="smartphone" appFeatherIcon
                          class="icon-sm mr-2"></i><span>{{'mb.sendLink' | translate}}</span></button>
                      <button ngbDropdownItem [disabled]="true"> <i data-feather="check-circle" appFeatherIcon
                          class="icon-sm mr-2"></i><span>{{'mb.markAsPaid' | translate}}</span></button>
                      <button ngbDropdownItem [disabled]="true"> <i data-feather="edit" appFeatherIcon
                          class="icon-sm mr-2"></i><span>{{'mb.editContract' | translate}}</span></button>

                    </div>
                  </div>
                </div>
              </div>

              <div class="chat-body">
                <div class="row">
                  <!-- <div class = "row"> -->
                  <!-- <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-account pr-1" aria-hidden></span>{{'customers.priorityId' | translate}}
                      <a class="loader_right pl-2">
                        <span placement="top" triggers="mouseenter:mouseleave">
                          <i class="link-icon feather icon-edit"></i>
                        </span>
                        <span *ngIf="false" class="spinner-border spinner-border-sm ml-2" role="status"
                          aria-hidden="true">
                        </span>
                      </a>
                    </dt>
                    <dd class="pl-4">{{viewInvoice?.priorityId || 'NA'}}</dd>
                  </div> -->
                  <!-- </div> -->
                  <!-- <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-account pr-1" aria-hidden></span>{{'invoice.merchant' | translate}}#</dt>
                    <dd class="pl-4">{{viewInvoice?.splitUpJSON?.totalMerchant || 'NA'}}</dd>
                  </div> -->
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-point-of-sale pr-1" aria-hidden></span>{{'invoice.tpn' | translate}}#</dt>
                    <dd class="pl-4">{{viewInvoice?.totalTpns || 'NA'}}</dd>
                  </div>
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.fixedFee' | translate}}
                    </dt>
                    <dd class="pl-4">{{viewInvoice?.fixedFee | currency : 'USD' : 'symbol' : '1.1-4'}}</dd>
                  </div>
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.spinFee' | translate}}
                    </dt>
                    <dd class="pl-4">{{viewInvoice?.spinFixedFee || 0 | currency : 'USD' : 'symbol' :
                      '1.1-4'
                      }}</dd>
                  </div>
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.setUpFee' | translate}}
                    </dt>
                    <dd class="pl-4">{{viewInvoice?.setupFixedFee || 0 | currency : 'USD' : 'symbol' :
                      '1.1-4' }}</dd>
                  </div>
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.variableFee' |
                      translate}}
                    </dt>
                    <dd class="pl-4">{{viewInvoice?.variableFee | currency : 'USD' : 'symbol' : '1.1-4'}}
                    </dd>
                  </div>
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.txSMSFee' | translate}}
                    </dt>
                    <dd class="pl-4">{{viewInvoice?.smsFee | currency : 'USD' : 'symbol' : '1.1-4'}}</dd>
                  </div>
                  <!-- <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.assetProtectionFee' |
                      translate}}</dt>
                    <dd class="pl-4">{{viewInvoice?.assetBilledAmount || 0 | currency : 'USD' : 'symbol' :
                      '1.1-4'}}</dd>
                  </div> -->
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.vasIntegrationFee' |
                      translate}}</dt>
                    <dd class="pl-4">{{viewInvoice?.vasIntegrationFee || 0 | currency : 'USD' : 'symbol' :
                      '1.1-4'}}</dd>
                  </div>
                  <!-- <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'invoice.promoSMSFee' |
                      translate}}</dt>
                    <dd class="pl-4">{{viewInvoice?.promotionalSmsFee | currency}}</dd>
                  </div> -->
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-cash-multiple pr-1" aria-hidden></span>{{'htmlText.isoAgentReference' |
                      translate}}</dt>
                    <dd class="pl-4">{{viewInvoice?.isoAgentReference || 'N/A'}}</dd>
                  </div>
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt>
                      <!-- <span class="mdi mdi-cash-multiple pr-1" aria-hidden></span> -->
                      {{'htmlText.isoMerchant' |
                      translate}}
                    </dt>
                    <dd class="pl-4">{{viewInvoice?.isoMerchant || 'N/A'}}</dd>
                  </div>
                  <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt>
                      <!-- <span class="mdi mdi-cash-multiple pr-1" aria-hidden></span> -->
                      {{'htmlText.ownedBy' |
                      translate}}
                    </dt>
                    <dd class="pl-0">{{viewInvoice?.ownedBy || 'N/A'}}</dd>
                  </div>
                  <!-- <div class="mt-2 col-md-4 col-lg-4 col-sm-6">
                    <dt><span class="mdi mdi-check-circle-outline pr-1" aria-hidden></span>{{'mb.markAsPaid' |
                      translate}}</dt>
                    <dd class="pl-4">{{viewInvoice?.paidMode && viewInvoice?.paidMode != 'NONE'
                      ?viewInvoice?.paidMode:"" }}</dd>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="billingNotebaled && !isLoading">
  <div class="row justify-content-center text-center mt-5">
    <div class="col-12 col-sm-8 col-md-6">
      <app-ilustration-with-message
        text="No Invoice data avaible for @{{filterMerchantInfo?.dba}}. Start billing this merchant"
        illustrationName="add.svg" severity="warn">
      </app-ilustration-with-message>
      <button type="button" class="btn btn-outline-primary btn-sm mt-3" style="min-width: 150px;"
        (click)="navigateToBilling()">
        {{'Start Billing' | translate}}
      </button>
    </div>
  </div>

</ng-container>

<app-loading *ngIf="isLoading"> </app-loading>